import type { AUTHENTICATION_INTENT, AUTHENTICATION_PROVIDERS } from '~/constants/authentication'

// Look into moving this to useAuthentication
export default function useSignup() {
  const authenticationModal = useAuthenticationModal()
  const authenticationType = useAuthenticationType()
  const authenticationIntent = useAuthenticationIntent()
  const { authenticationProvider } = useAuthentication()
  const enquiryOwnerName = useEnquiryOwnerName()

  const intentCookie = useIntentCookie()
  const redirectCookie = useRedirectCookie()

  function showSignup(params?: {
    intent?: AUTHENTICATION_INTENT
    ownerName?: string
    provider?: AUTHENTICATION_PROVIDERS // Only support email for now
    redirectTo?: string
  }) {
    const { intent, ownerName, provider, redirectTo } = params ?? {}

    authenticationProvider.value = provider
    authenticationIntent.value = intent
    enquiryOwnerName.value = ownerName
    authenticationType.value = 'Signup'
    authenticationModal.value = true

    intentCookie.value = intent ?? null

    if (redirectTo) {
      redirectCookie.value = redirectTo
    }
  }

  const isSignupVisible = computed(() => authenticationType.value === 'Signup')

  return {
    isSignupVisible,
    authenticationIntent,
    showSignup,
  }
}
